import { clsx } from 'clsx';
import qs from 'qs';
import { twMerge } from 'tailwind-merge';
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
export const formatTotalUser = ({ value }) => {
    return `${value} ユーザー`;
};
export const formatUserWithLabel = ({ value, label }) => {
    return `${value} ${label}`;
};
export function buildQueryString(params) {
    return qs.stringify(params, {
        encode: false,
        arrayFormat: 'comma'
    });
}
export const filterAllowedParams = (params, allowKeys) => Object.fromEntries(Object.entries(params).filter(([key, value]) => allowKeys.includes(key) && value !== undefined && value !== null && value !== ''));
export const mapSorterToParams = sorter => {
    if (Array.isArray(sorter))
        return {};
    if (!sorter.field || !sorter.order) {
        return {
            sort_by: undefined,
            order: undefined
        };
    }
    return {
        sort_by: String(sorter.field),
        order: sorter.order === 'ascend' ? 'asc' : 'desc'
    };
};
